import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Error, Typography } from 'shared/ui'
import { makeTextFieldAutoFocus, makeTextFieldHighlight, TextField } from 'shared/ui/TextField'
import { InputPassword } from 'shared/ui/TextField/InputPresets/InputPassword'
import { type ProfileStore } from 'pages/settings/pages/personal/pages/account/pages/profile'
import styles from 'pages/auth/pages/login/ui/Login/ui/LoginForm/styles.module.scss'

type ICheckCurrentPasswordModalProps = {
  store: ProfileStore
  field: string
}

export const CheckCurrentPasswordModal = observer(
  ({ store, field }: ICheckCurrentPasswordModalProps) => {
    const { currentPassword, setCurrentPassword, errorsMap, loading } = store
    const passwordError = errorsMap.get('current_password')

    return (
      <>
        <Typography
          variant='body-md-medium'
          ariaLabel='Reset password description'
          tag={'div'}
          marginTop={4}
        >
          Current password
        </Typography>
        <Typography
          variant='body-md-regular'
          color='var(--content-primary-tertiary)'
          ariaLabel='Reset password description'
          tag={'div'}
          marginTop={4}
          marginBottom={24}
        >
          Confirm your identity before changing your {field}
        </Typography>
        <TextField
          Input={InputPassword}
          className={classNames(styles.textField, {
            [styles.error]: !!passwordError,
          })}
          variant='stroke'
          InputProps={{
            placeholder: 'Enter your password',
          }}
          error={!!passwordError}
          disabled={loading}
          size='medium'
          onChange={setCurrentPassword}
          value={currentPassword}
          mainActions={[
            makeTextFieldAutoFocus({ withFocus: true }),
            makeTextFieldHighlight({ mode: 'error', highlight: !!passwordError }),
          ]}
        />
        <Error type={'text'} error={passwordError} />
      </>
    )
  }
)
